export default __webpack_public_path__ + "static/media/userIcon.10691648.png";